import React, { useState, useEffect, } from 'react';
import { useHistory,useParams } from 'react-router-dom';
import { Button, Image, } from 'react-bootstrap';
import { hideLoader, showLoader } from 'store/actions/commons';
import { useStore } from 'store';
import { useWindowSize } from 'hooks';
import { Back, CustomDatePicker } from 'components';
import { infoMiniTemplate, infoTemplate, postImportExcel, postInvitation, infoInvitation, putGuestsDate } from 'services/rsvp/getRSVP';
import { SHARE_LINKS, SHARE_LINKS_TABLE } from 'components/gifts-table/TableShareWidget/config';
import excel from 'assets/img/excel.png';
import icono_agrega_invitado from 'assets/img/icono_agrega_invitado.png';
import deleteBlueIcon from 'assets/img/delete-blue.svg';
import InvitationFrom from './InvitationFrom';
import InvitationFromImage from './InvitationFromImage';
import InvitationFormMobile from './InvitationFormMobile';
import TemplateDownload from './TemplateDownload';
import TemplateUpload from './TemplateUpload';
import TemplateUploadMobile from './TemplateUploadMobile';
import styles from './styles.module.scss';

function MyGuestsExcelLanding({
  tableInfo,
}) {
  console.log('tableInfo?.evento', tableInfo);
  const { isMobile } = useWindowSize({ largeMobile: true })[1];
  const history = useHistory();
  const [, dispatch] = useStore((state) => state.giftTable.giftTable);
  const [paso, setPaso] = useState(1);
  const [nombreArchivo, setNombreArchivo] = useState(null);
  const [typeId, setTypeId] = useState(tableInfo?.evento);
  const [url, setUrl] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [selectedDate, setSelectedDate] = useState(false);
  const [selectedDateDB, setSelectedDateDB] = useState(null);
  const [template, setTemplate] = useState(null);
  const [formDatainvitation, setformDatainvitation] = useState(null);
  const [miniTemplate, setMiniTemplate] = useState(null);
  const [shareUrl, setShareUrl] = useState(window.location.origin + '/Mesa-de-Regalos/invitation/' + typeId);
  const [jsonResultado, setJsonResultado] = useState(null);
  const [idTemplate, setIdTemplate] = useState(null);
  const [marginTop, setMarginTop] = useState('150px');
  const [timeSleep, setTimeSleep] = useState(1);
  const [dateSend, setDateSend] = useState(null);
  const [configurationDesktop, setConfigurationDesktop] = useState({});
  const [botonSave, setBotonSave] = useState(false);

  console.log('typeId', typeId);
  console.log('botonSave',botonSave);

  let { indicaPaso } = useParams();
  console.log('indicaPaso', indicaPaso);

  const { load } = useParams();
  console.log('load', load);

  const handleAddGuestsExcel = () => {
    setPaso(2);
  };

  const handleAddGuest = () => {
    history.push('/agrega-invitados');
  };

  const handleClickInicio = () => {
    history.push('/rsvp');
  };

  const handleClickAtras = () => {
    if (load === 'load') {
      history.push('/rsvp');
    }else{
      if(paso>1) setPaso(paso - 1);
      else history.push('/rsvp');
    }
  };

  const handleNextSteps = () => {
    setPaso(paso + 1);
  };

  const handleUrl = (url) => {
    console.log('url en padre', url?.ruta_file);
    setUrl(url?.ruta_file);
    setNombreArchivo(url?.nombre_archivo);
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = url;
    link.click();
  };

  const handleReplaceList = () => {
    setPaso(2);
  };

  const handleContinue = () => {
    //     CREA JSON PARA ENVIAR AL SERVICIO DE CARGA DE EXCEL
    const excel_file = url;
    const nuevoRegistro = {
      excel_file
    };

    // Actualizar el estado del resultado JSON
    setJsonResultado(nuevoRegistro);
  };

  const handleDateSave = () => {
    console.log('date paso 4:', inputValue);
    setSelectedDate(!selectedDate);
    setSelectedDateDB(inputValue);
    setPaso(5);
  };

  const handleTemplateClick = (templateId) => {
    //       LLAMAR A SERVICIO PARA RECUPERAR TEMPLATE
    infoTemplate(templateId).then((valorDeServicio) => {
      console.log('infoTemplate serivico recupera template', valorDeServicio);
      setTemplate(valorDeServicio?.data?.[0].url);
      setIdTemplate(templateId);
      try {
        const configurationDesktop = JSON.parse(valorDeServicio?.data?.[0].configuration_desktop);
        setConfigurationDesktop(configurationDesktop);
      } catch (error) {
        console.error('Error al analizar la configuración de escritorio JSON:', error);
      }
    });
    setPaso(6);
  };

  console.log('template', template);

  const handleFormData = (data) => {
    setformDatainvitation(JSON.parse(data));
    console.log('data en padre', data);
  };

  const handleSaveFormData = () => {
    //      LLAMAR METODO PARA GUARDAR INFO
    formDatainvitation.event_date = formDatainvitation.event_date + ' ' + formDatainvitation.time ;
    formDatainvitation.giftTableId = typeId;
    formDatainvitation.catalog_invitation_template_id = idTemplate;
    formDatainvitation.celebrate_last_name = null;
    console.log('handleSaveFormData', formDatainvitation);

    //      LLAMAR METODO PARA GUARDAR INFO INVITACION
    postInvitation(typeId, formDatainvitation).then((valorDeServicio) => {
      console.log('postInvitation', valorDeServicio);
      setPaso(7);
    });
  };

  const handleGiftsTable = () => {
    history.push('/');
  };

  const handleTimeSleep = (time) => {
    console.log('Vamos a dormir: ',time);
    if(time > 120)
      {setTimeSleep(120);}
    else
      {setTimeSleep(time);}
  };

  console.log('timeSleep', timeSleep);

  useEffect(() => {
    console.log('dateSend',dateSend);
    if(dateSend === null || dateSend === 404 ){
      const updatedData = {
        event_name: "",
        event_date: "",
        time: "",
        celebrate_name: "",
        address: "",
        message: "",
        giftTableId: typeId,
        catalog_invitation_template_id: "",
        celebrate_last_name: "",
        scheduled_invitation_delivery_date: selectedDateDB
      };
      postInvitation(typeId, updatedData).then((valorDeServicio) => {
        console.log('Guarda Fecha Envio postInvitation ', valorDeServicio);
      });
    }else{
      const updatedData = { fecha: selectedDateDB };
      putGuestsDate(typeId, updatedData).then((valorDeServicio) => {
        console.log('Guarda Fecha Envio putGuestsDate ', valorDeServicio);
      });
    }
  }, [selectedDate]);

  useEffect(() => {
    console.log('Valiendando paso ', paso);

    if(paso == 4){
      //     LLAMAR SERVICIO PARA RECUPERAR FECHA DE INVITACION
      infoInvitation(typeId).then((valorDeServicio) => {
        console.log('infoInvitation serivico recupera fecha invitacion en paso 4', valorDeServicio);
        setDateSend(valorDeServicio?.metadata?.http_status);
        setInputValue(valorDeServicio?.data?.scheduled_invitation_delivery_date);
      });

      if(timeSleep > 0){
      dispatch(showLoader());
        setTimeout(() => {
          dispatch(hideLoader());
          console.log('Durmiendo', timeSleep);
        }, timeSleep*1000);
      }
    }

    if (paso == 5) {
      //      LLAMAR DECARGAR IMGANES DE TEMPLATES MINI
      console.log('Llamar servicio de descarga de imagenes de templates');
      infoMiniTemplate().then((valorDeServicio) => {
        setMiniTemplate(valorDeServicio.data);
        console.log('infoMiniTemplate serivico', valorDeServicio);
      });
    }

    window.scrollTo(0, 0);

    if(paso == 6){
        console.log('Use effect indicaPaso condicion', indicaPaso);
        dispatch(showLoader());
        infoInvitation(typeId).then((valorDeServicio) => {
          console.log('infoInvitation serivico recupera invitacion en paso 6', valorDeServicio);

          if(valorDeServicio?.metadata?.http_status !== 404){
            if(template == null) {
              setTemplate(valorDeServicio?.data?.template_url);
              setIdTemplate(valorDeServicio?.data?.catalog_invitation_template_id);
            }

            const tmpDataInvitacion = {
              "event_name": valorDeServicio?.data?.event_name,
              "event_date": valorDeServicio?.data?.event_date,
              "time": valorDeServicio?.data?.event_hour,
              "celebrate_name": valorDeServicio?.data?.name,
              "address": valorDeServicio?.data?.address,
              "message": valorDeServicio?.data?.message
            };
            console.log('Set formDatainvitation', tmpDataInvitacion);
            setformDatainvitation(tmpDataInvitacion);
            dispatch(hideLoader());
          }
        });
      }
  }, [paso]);

  useEffect(() => {
    //      SI SE QUIERE IR A UN PASO EN ESPECIFICO
    if (indicaPaso) {
      setPaso(indicaPaso);
    }
  }, [indicaPaso]);

  useEffect(() => {
    if (jsonResultado !== null) {
      dispatch(showLoader());

      //     CONSUME SERVICIO GUARDA EXCEL
      postImportExcel(typeId, jsonResultado)
        .then((valorDeServicio) => {
          console.log('postImportExcel ', valorDeServicio);
          dispatch(hideLoader());
          setPaso(4);
        })
        .catch((error) => {
          // Manejar cualquier error que pueda ocurrir durante la llamada
          console.error('Error al llamar a postImportExcel: ', error);
          dispatch(hideLoader());
          setPaso(4);
        });
    }
  }, [jsonResultado]);

  useEffect(() => {
    if (typeId === undefined) {
      history.push('/');
    }
  }, [typeId]);

  console.log('paso', paso);
  console.log('configurationDesktop',configurationDesktop);

  useEffect(() => {
    const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
    if (isFirefox) {
      setMarginTop('200px');
    } else {
      setMarginTop('150px');
    }

    if (load === 'load') {
      //       LLAMAR A SERVICIO PARA RECUPERAR TEMPLATE
      infoInvitation(typeId).then((valorDeServicio) => {
        console.log('infoInvitation serivico recupera CSS', valorDeServicio);
              //setTemplate(valorDeServicio?.data?.[0].url);
             // setIdTemplate(templateId);
        try {
          const configurationDesktop = JSON.parse(valorDeServicio?.data?.configuration_desktop);
          setConfigurationDesktop(configurationDesktop);
        } catch (error) {
          console.error('Error al analizar la configuración de escritorio JSON:', error);
        }
      });
    }

  }, []);
  console.log('formDatainvitation',formDatainvitation);

  const handleChangeCustomDatePicker = (e) => {
    setInputValue(e.target.value);
    setSelectedDateDB(e.target.value);
    console.log('date paso 4:', e.target.value);
  };

  useEffect(() => {
    console.log('inputValue',inputValue);
    const selectedDateValue = inputValue;
    const currentDate = new Date();
    const unixTimestamp = Math.floor(currentDate.getTime() / 1000);
    const selectedDateunixTimestamp = Math.floor(new Date(selectedDateValue).getTime() / 1000);

    // Validación de fecha
    if (selectedDateunixTimestamp < unixTimestamp) {
      alert ('No puedes seleccionar fechas anteriores o igual a la actual.');
      setBotonSave(true);
    } else {
      setBotonSave(false);
    }
  },[inputValue]);

  return (
    <>
      {isMobile && (<Back onClick={handleClickAtras} title='Lista de invitados' handleFunction/>)}
      <div className={styles.container}>
        {paso == 1 && (
          <div>
            {!isMobile && (
              <>
                <span className="float-left" onClick={handleClickInicio}><i className="fa fa-arrow-left" aria-hidden="true"></i>  Regresar</span>&nbsp; &nbsp;
              </>
            )}

            <div className="mt-2 text-center">
              <span className="badge badge-danger p-2" style={{ backgroundColor: 'white', color: 'red', border: '1px solid red', borderRadius: '8px' }}>1 de 3</span>
            </div>
            <br />{!isMobile && (<br />)}
            <div className="text-center" style={{fontSize: isMobile?'1.2rem':'1.5rem', fontWeight: '800', marginBottom: isMobile?'10px':'50px'}}>1. ¿Cómo quieres agregar a tus invitados?</div>
            <div className='d-flex justify-content-center flex-wrap col-md-12'>
              <div
                className="shadow border rounded p-4 text-center mb-3 col-md-5"
                style={{ maxWidth: '200px', width: '100%', cursor: 'pointer', marginRight: isMobile?'0px':'20px'}}
                onClick={handleAddGuestsExcel}>
                <img src={excel} alt="Agregar lista de excel" /><br /><br />
                Agregar lista<br />de excel
              </div>
              {isMobile && (<div className="col-md-2" />)}
              <div
                className="shadow border rounded p-4 text-center mb-3 col-md-5"
                style={{ maxWidth: '200px', width: '100%', cursor: 'pointer', marginLeft: isMobile?'0px':'20px'}}
                onClick={handleAddGuest}>
                <img src={icono_agrega_invitado} alt="Agregar manualmente"/><br /><br />
                Agregar<br />manualmente
              </div>
            </div>
            <br />
          </div>
        )}

        {paso == 2 && (
          <div>
            {!isMobile && (
              <>
                <span className="float-left" onClick={handleClickAtras}><i class="fa fa-arrow-left" aria-hidden="true"></i>  Regresar</span>&nbsp; &nbsp;
              </>)}
            <div className="mt-1 text-center">
              <span className="badge badge-danger p-2" style={{ backgroundColor: 'white', color: 'red', border: '1px solid red', borderRadius: '8px' }}>1 de 3</span>
            </div>
            <br />{!isMobile && (<br />)}
            <div className="text-center" style={{fontSize: !isMobile?'1.5rem':'1.2rem', fontWeight: '800', marginBottom: isMobile?'10px':'30px'}}>Agrega tus invitados</div>
            {isMobile ? (
              <div>
                <div className='text-justify' style={{fontSize: '.98rem'}}>Para comenzar sigue estos sencillos pasos:</div>
                <div className="justify-content-center w-100">
                  <div className='w-100' style={{fontWeight: '800', margin: 10, fontSize: '.97rem'}}>1. Descarga la plantilla</div>
                  <div className='w-100' style={{fontWeight: '800', margin: 10, fontSize: '.97rem'}}>2. Llénala sin modificar el formato*</div>
                  <div className='w-100' style={{fontWeight: '800', margin: 10, fontSize: '.97rem'}}>3. Subela de nuevo</div>
                </div>
              </div>
            ) : (
              <div className="text-center">
                <h5>Para comenzar sigue estos sencillos pasos:</h5>
                <ol className="list-unstyled">
                  <li>1. Descarga la plantilla</li>
                  <li>2. Llénala sin modificar el formato*</li>
                  <li>3. Subela de nuevo</li>
                </ol>
              </div>
            )}
            <div className={`${!isMobile?'d-flex ':''}justify-content-center`}>
              <div className={`${isMobile?'col-md-12 my-4':'col-md-2'}`}><TemplateDownload /></div>
              <div className={`${isMobile?'col-md-12 my-4':'col-md-2'}`}>
                {!isMobile?(
                  <TemplateUpload typeId={tableInfo?.evento} handleNextStepsFather={handleNextSteps} handleUrlFather={handleUrl} handleTimeSleepFather={handleTimeSleep} />
                ):
                <TemplateUploadMobile typeId={tableInfo?.evento} handleNextStepsFather={handleNextSteps} handleUrlFather={handleUrl} handleTimeSleepFather={handleTimeSleep} />}
              </div>
            </div>
            <br /><p>*Es importante que no edites el formato de la plantilla para no generar un error al subirla de nuevo</p><br />
          </div>
        )}

        {paso == 3 && (
          <div className="text-center">
            {!isMobile && (
              <>
                <span className="float-left" onClick={handleClickAtras}><i class="fa fa-arrow-left" aria-hidden="true"></i>  Regresar</span>&nbsp; &nbsp;
              </>
            )}

            <div className="mt-2">
              <span className="badge badge-danger p-2" style={{ backgroundColor: 'white', color: 'red', border: '1px solid red', borderRadius: '8px' }}>1 de 3</span>
            </div>
            <br />{!isMobile && (<br />)}
            <div className="text-center" style={{fontSize: !isMobile?'1.5rem':'1.2rem', fontWeight: '800', marginBottom: isMobile?'10px':'30px'}}>1. ¿Cómo quieres agregar a tus{!isMobile?(<br />):(' ')}invitados?</div>
            <div className="d-flex justify-content-center">
              <div className="d-flex">
                <div className="shadow border rounded p-4 text-center mx-auto" style={{ maxWidth: '200px', width: '100%' }}>
                  <img src={excel} alt="Icono de Excel" /><br />
                  <div className='d-flex' style={{ alignItems: 'baseline' }}>
                    <div>
                      <a href="#" style={{ fontSize: 'small', color: isMobile?'#057fc8':'#ed0045' }} onClick={(e) => { e.preventDefault(); handleDownload(); }}>
                      {nombreArchivo}
                      </a>
                    </div>
                    <div>
                      <img src={deleteBlueIcon} alt="Eliminar lista" onClick={handleReplaceList} style={{color:'#057fc8', cursor:'pointer'}} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br /><br />
            <div className={`${!isMobile?'d-flex ':''}justify-content-center`}>
              <div className={`${isMobile?'col-md-12 mt-4':'col-md-2'}`}>
                <Button
                  id={31}
                  block
                  variant="secondary"
                  onClick={handleReplaceList}
                  type="button"
                  className={'text-danger'}>
                  Reemplazar lista
                </Button>
              </div>
              <div className={`${isMobile?'col-md-12 mt-4':'col-md-2'}`}>
                <Button
                  id={32}
                  block
                  variant="primary"
                  onClick={handleContinue}
                  type="button"
                  className={''}>
                  Continuar
                </Button>
              </div>
            </div>
            <br /><br />
          </div>
        )}

        {paso == 4 && (
          <div>
            {!isMobile && (
              <>
                <span className="float-left" onClick={handleClickAtras}><i className="fa fa-arrow-left" aria-hidden="true"></i>  Regresar</span>&nbsp; &nbsp;
              </>
            )}
            <div className="mt-2 text-center">
              <span className="badge badge-danger p-2" style={{ backgroundColor: 'white', color: 'red', border: '1px solid red', borderRadius: '8px' }}>1 de 3</span>
            </div>
            <br />
            <div className="text-center" style={{fontSize: !isMobile?'1.5rem':'1.2rem', fontWeight: '800', marginBottom: isMobile?'10px':'30px'}}>Programar envío</div>
            <div className="text-center" style={{fontSize: isMobile?'.8rem':'1rem'}}>Programa la fecha en la que deseas que se envíe tu invitación automáticamente.</div>
            <div className="text-center" style={{marginTop: isMobile?30:0}}>
              <div className="text-center" style={{fontSize: !isMobile?'1.5rem':'1.2rem', fontWeight: '800', marginBottom: isMobile?'10px':'30px'}}>
                2. ¿Cuándo quieres enviar tu{!isMobile?(<br />):(' ')}invitación?
              </div>
              {!isMobile && (<br />)}
              <div>
              {!isMobile ? (
                <input
                  selected={selectedDate}
                  onChange={(e) => setInputValue(e.target.value)}
                  type="date"
                  className={styles.inputborder}
                  value={inputValue}
                />
              ) : (
                <CustomDatePicker name='rsvp_date' maxLength={50} selected={selectedDate}
                  change={handleChangeCustomDatePicker}
                  value={inputValue} />
              )}
              </div>
              <br />
              <div className="d-flex align-items-center justify-content-center">
                <Button
                  id={320}
                  variant="primary"
                  onClick={handleDateSave}
                  type="button"
                  className={''}
                  disabled={botonSave}
                  style={{ maxWidth: '250px', width: '100%' }}
                >
                  Guardar
                </Button>
              </div>
              <br /><br /><br /><br /><br /><br />
            </div>
          </div>

        )}

        {paso == 5 && (
          <div>
            {!isMobile && (
              <>
                <span className="float-left" onClick={handleClickAtras}><i className="fa fa-arrow-left" aria-hidden="true"></i>  Regresar</span>&nbsp; &nbsp;
              </>
            )}
            <div className="mt-2 text-center">
              <span className="badge badge-danger p-2" style={{ backgroundColor: 'white', color: 'red', border: '1px solid red', borderRadius: '8px' }}>3 de 3</span>
            </div>
            <br />
            <div className="text-center" style={{fontSize: !isMobile?'1.5rem':'1.2rem', fontWeight: '800', marginBottom: isMobile?'10px':'30px'}}>3. Elige tu diseño</div>
            <p className="text-center">Elige el tema que más te guste</p>
            <div className={`row${!isMobile?' justify-content-center':''}`}>
              {miniTemplate !== null ? (
                miniTemplate.map((item, index) => (
                  <div
                    key={item.template_id} onClick={() => handleTemplateClick(item.id)}
                    className={`cursor-pointer ${!isMobile?'col-6 col-sm-3 col-md-3 col-lg-3 text-center m-2':`col-6 col-sm-6 ${ index % 2 !== 2 - 1 ? 'border-right' : '' } ${index < miniTemplate.length - 2 ? 'border-bottom' : ''}`}`}
                    style={{padding: '10px 0px 10px 0px', height: isMobile?130:'', cursor: 'pointer'}}>
                    <img
                      src={item.url_mini}
                      alt={item.name}
                      style={{width:!isMobile?120:'90%', height: !isMobile?100:'90%'}} 
                      className={`${isMobile && 'img-fluid rounded'}`}
                      />
                    {!isMobile?(<p>{item.name}</p>):(<div style={{fontSize:'0.55rem', marginTop: '3px'}}>{item.name}</div>)}
                  </div>
                ))
              ) : (
                <p>Cargando . . .</p>
              )}
            </div>
          </div>

        )}

        {paso == 6 && (
        <div>
          {!isMobile && (
            <>
              <span className="float-left" onClick={handleClickAtras}><i className="fa fa-arrow-left" aria-hidden="true"></i>  Regresar</span>&nbsp; &nbsp;
            </>
          )}
          <div className="mt-2 text-center">
            <span className="badge badge-danger p-2" style={{ backgroundColor: 'white', color: 'red', border: '1px solid red', borderRadius: '8px' }}>2 de 3</span>
          </div>
          <br />
          <div className="text-center" style={{fontSize: !isMobile?'1.5rem':'1.2rem', fontWeight: '800', marginBottom: isMobile?'10px':'30px'}}>{!isMobile && ('3. ')}Personaliza tu invitación</div>
          <br />
          {!isMobile ? (
            <div className="d-flex flex-wrap justify-content-center">
              <div className='col-md-4 col-sm-6 mb-3'>
                <InvitationFrom handleFormDataFather={handleFormData} handleClickBackFather={handleClickAtras} handleSaveFormDataFather={handleSaveFormData} data={formDatainvitation} etapa={paso} handleLoad={load}/>
              </div>
              <div className='col-md-4 col-sm-6 mb-3'>
                <InvitationFromImage data={formDatainvitation} imgInvitation={template} typeIdFather={typeId} etapa={6} configurationDesktopInv={configurationDesktop}/>
              </div>
              <br />
            </div>
          ):(
            <div className="row">
              <div className='col-md-12'>
                <InvitationFormMobile handleFormDataFather={handleFormData} handleClickBackFather={handleClickAtras}  configurationMobile={configurationDesktop} handleSaveFormDataFather={handleSaveFormData} data={formDatainvitation} etapa={paso} imgInvitation={template} typeIdFather={typeId} />
              </div>
              <br />
            </div>
          )}
          <br />
        </div>

        )}

        {paso == 7 && (
          <div>
            {!isMobile && (
              <>
                <span className="float-left" onClick={handleClickAtras}>
                  <i className="fa fa-arrow-left" aria-hidden="true"></i> Regresar
                </span>&nbsp; &nbsp;
              </>
            )}
            <h1 className="text-center">¡Tu invitación está lista!</h1>
            <div className="d-flex flex-wrap justify-content-center">
              <div className='col-md-4 col-sm-6 mb-3'>
                <InvitationFromImage data={formDatainvitation} imgInvitation={template} typeIdFather={typeId} configurationDesktopInv={configurationDesktop}/>
              </div>
            </div>
            <div className="text-center">
              <p style={{ marginTop: marginTop }}>La confirmación de asistencia se hará vía correo electrónico.</p>
              <p>
                Compartir vía:
                <div className="d-flex justify-content-center">
                  {SHARE_LINKS_TABLE.map(({ id, icon, alt, getLink }) => (
                    <span key={id} className="d-inline-flex align-items-center mr-3">
                      <a
                        href={getLink(shareUrl)}
                        alt={alt}
                        rel={id === 'twitter' && 'noreferrer'}
                        target='_blank'
                        className="text-decoration-none"
                      >
                        <Image src={icon} alt={alt} className="mr-2" />
                        {id === 'facebook' && <span className="sr-only">{alt}</span>}
                      </a>
                    </span>
                  ))}
                </div>
              </p>
              <br />
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <Button
                id={321}
                block
                variant="primary"
                onClick={handleGiftsTable}
                type="button"
                className={''}
                style={{ maxWidth: '250px', width: '100%' }}
              >
                Ver mi mesa de regalos
              </Button>
            </div>
            <br />
          </div>
        )}
      </div>
    </>
  );
}

export default MyGuestsExcelLanding;
